import {
  createAction,
  addListener as addListenerAction,
  removeListener as removeListenerAction,
  clearAllListeners as clearAllListenersAction,
} from '@reduxjs/toolkit';
export { addListenerAction, removeListenerAction, clearAllListenersAction };

export const bootType = 'rtk/@@boot';

export const boot = createAction(bootType);
